import { requestSaga } from 'common/utils/generators';
import resources from 'common/constants/resources';
import dataProvider from 'store/dataProvider';
import { patientsActionTypes } from '../reducer';

function* updatePatient() {
  yield requestSaga({
    actionType: patientsActionTypes.update,
    request: dataProvider.updateOne,
    resource: resources.patient.index,
  });
}

export default updatePatient;
